import {
  ColumnFilterModel,
  FilterEditorRowModel,
} from '../models/filter-editor.model'
import { BuiltinFilterOperator } from '../models/filter-operator.model'
import {
  FilterState,
  ScalarFilterState,
  SetFilterOptionModel,
  SetFilterState,
  SetFilterType,
} from '../models/filter.model'

/**
 * Create a FilterState from a FilterEditorRowModel object.
 */
export function createFilterState(
  rowModel: FilterEditorRowModel,
): FilterState | undefined {
  if (!rowModel.column || !rowModel.operator) {
    return undefined
  }

  const filterType = rowModel.column.filterType.type
  const type = rowModel.operator.type

  switch (filterType) {
    case 'set': {
      const options = rowModel.filterValue as SetFilterOptionModel[]
      const values = options.map(opt => opt.key)
      return {
        filterType,
        values,
      } as SetFilterState
    }
    default: {
      const filterState = {
        filterType,
        type,
        filter: rowModel.filterValue,
      } as ScalarFilterState

      if (type === 'blank' || type === 'notBlank') {
        filterState.filter = type
      }

      if (rowModel.filterToValue) {
        filterState.filterTo = rowModel.filterToValue as string
      }

      if (filterState.filterType === 'identifier') {
        filterState.filterType = 'number'
      }

      return filterState
    }
  }
}

/**
 * Create filter row form group from filter state
 */
export async function createFilterRowModel(
  columnFilters: ColumnFilterModel[],
  id: number,
  field: string,
  state?: FilterState,
): Promise<FilterEditorRowModel> {
  const column = columnFilters.find(col => col.field === field)

  switch (state?.filterType) {
    case 'set': {
      const setFilterType = column?.filterType as SetFilterType
      const options = await setFilterType.options
      const values = state?.values ?? []
      const selectedOptions = options.filter(opt => values.includes(opt.key))
      return {
        id,
        column,
        operator: BuiltinFilterOperator.in,
        filterValue: selectedOptions,
      }
    }
    default: {
      const operators = column?.operators ?? []
      const operator = operators.find(op => op.type === state?.type)

      return {
        id,
        column,
        operator,
        filterValue: state?.filter as string | undefined,
        filterToValue: state?.filterTo as string | undefined,
      }
    }
  }
}
